import PreLoginWrapper from "@/modules/login/PreLoginWrapper";
import React from "react";

const PreLogin: React.FC = () => {
  return <PreLoginWrapper />;
};

export default PreLogin;
